import type { ReaderName } from "@bindery/shared/contracts/session";
import { cn } from "@bindery/ui/lib/utils";
import { readerDisplayName } from "../lib/reader-name";

export function ReaderPicker({
  readers,
  boundReaderId,
  onPick,
}: {
  readers: readonly ReaderName[];
  boundReaderId: string | null;
  onPick: (readerId: string) => void;
}) {
  if (readers.length === 0) {
    return (
      <p className="text-muted-foreground">
        No readers are linked to this account yet. Link a reader first, then
        come back to print for them.
      </p>
    );
  }
  return (
    <ul className="flex flex-wrap gap-2" aria-label="Readers">
      {readers.map((reader) => {
        const bound = reader.readerId === boundReaderId;
        return (
          <li key={reader.readerId}>
            <button
              type="button"
              aria-pressed={bound}
              disabled={bound}
              onClick={() => onPick(reader.readerId)}
              className={cn(
                "rounded-full border px-4 py-1.5 font-serif text-lg transition-colors outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50",
                bound
                  ? "border-foreground bg-foreground text-background"
                  : "border-border bg-background hover:border-foreground",
              )}
            >
              {readerDisplayName(reader)}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
